import { decode } from 'html-entities';
import { PROGRESS_COLORS, REDIRECT_FROM_SN } from '../storage';
import sanitizeHtml from 'sanitize-html'
import moment from "moment/moment";

const currentDate = new Date()

const urlRegex = /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/i
const exceptLettersRegex = new RegExp(/[^a-zA-Z]+/, 'gi')

const HOSTS_MAP = {
  "next.wonsulting.ai": 'next',
  "app.wonsulting.ai": 'production',
  "staging.wonsulting.ai": 'staging'
}

const getCurrentVersion = () => {
  return process.env.MIX_APP_VERSION ?? 1
}

export const isReferralEnabled = () => {
  return process.env.MIX_REFERRAL_ENABLED === "true" ? true : false
}

export const isSurveyEnabled = () => {
  return process.env.MIX_SHOW_SURVEY === "true" ? true : false
}

export const isResumeScorerEnabled = () => {
  return process.env.MIX_SHOW_RESUME_SCORER === "true" ? true : false
}

export const isInterviewAiEnabled = () => {
  return process.env.MIX_SHOW_INTERVIEW_AI === "true" ? true : false
}

export const isJobTrackerEnabled = () => {
  return process.env.MIX_SHOW_JOB_TRACKER_AI === "true" ? true : false
}

export const isCommunityEnabled = () => {
    return process.env.MIX_SHOW_COMMUNITY === "true" ? true : false
}

export const isJobBoardAiEnabled = () => {
  return process.env.MIX_SHOW_JOB_BOARD_AI === "true" ? true : false
}

const isSubscriptionModelActivated = () => {
  return process.env.MIX_SHOW_SUBSCRIPTION_MODEL=='true' ?? false
}

const isJobSearchBlockersEnabled = () => {
  return process.env.MIX_SHOW_JOB_SEARCH_BLOCKERS=='true' ?? false
}

const isTailorTargetButtonEnabled = () => {
  return process.env.MIX_SHOW_TAILOR_BUTTON=='true' ?? false
}

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

const isValidHttpUrl = (value) => {
  return /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi.test(value);
}

const isValidUrl = (url) => {
    return urlRegex.test(url)
}

const copyToClipboard = (text) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function() {
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
}

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function hexToRgb(string){
  if(string.length != 6){
      throw "Only six-digit hex colors are allowed.";
  }

  var aRgbHex = string.match(/.{1,2}/g);
  var aRgb = [
      parseInt(aRgbHex[0], 16),
      parseInt(aRgbHex[1], 16),
      parseInt(aRgbHex[2], 16)
  ];
  return aRgb;
}

function makeid(length = 6) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

const formatErrors = (errors) => {
    let formatErrors = {}
    Object.keys(errors).forEach(el => {
        let value = errors[el]
        formatErrors[el] = !Array.isArray(value) ? [value] : value
    })
    return formatErrors
}

const popupwindow = (url, title, w, h) => {
    var left = (screen.width/2)-(w/2);
    var top = (screen.height/2)-(h/2);
    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
} 

const roundNearest = (num, tick = 15) => {
    return Math.round(num / tick) * tick;
}

const sort_by_key = (array, key) => {
 return array.sort(function(a, b) {
  var x = a[key]; var y = b[key];
  return ((x < y) ? -1 : ((x > y) ? 1 : 0));
 });
}

const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

function extractContent(s) {
  var span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
}

const decodeHtmlEntities = (text) => {
    return decode(text ??  '').replace(/<br\s*[\/]?>/gi, '\n')
}

const calcScreenDPI = () => {
    const el = document.createElement('div');
    el.style = 'width: 1in;'
    document.body.appendChild(el);
    const dpi = el.offsetWidth;
    document.body.removeChild(el);
  
    return dpi;
}
  
  const getHeightForA4Page = (ppiHeight) => {
    const sizes = {
      72: 842,
      96: 1123,
      150: 1754,
      300: 3508,
      600: 7016,
    }
  
    return sizes?.[ppiHeight] ?? sizes[72]
}

  const isInViewport = (element) => {
    const rect = element?.getBoundingClientRect();

    if(rect != null) {
      return (
        rect.top >= 0 &&
        rect.left >= 0 && 
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    return false
}

function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

//initialize throttlePause variable outside throttle function
let throttlePause;
 
const throttle = (callback, time) => {
  //don't run the function if throttlePause is true
  if (throttlePause) return;
 
  //set throttlePause to true after the if condition. This allows the function to be run once
  throttlePause = true;
   
  //setTimeout runs the callback within the specified time
  setTimeout(() => {
    callback();
     
    //throttlePause is set to false once the function has been called, allowing the throttle function to loop
    throttlePause = false;
  }, time);
}

const capitalizeFirstLetterEveryWord = (string) => {
    const words = string.split(" ");
    
    return words.map((word) => { 
        return word[0].toUpperCase() + word.substring(1); 
    }).join(" ");
}

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const arraytoList = array => {
    // Create the list element:
    var list = document.createDocumentFragment('ul');
 
   for (var i = 0; i < array.length; i++) {
       // Create the list item:
       var item = document.createElement('li');
 
       // Set its contents:
       item.appendChild(document.createTextNode(array[i]));
 
       // Add it to the list:
       list.appendChild(item);
   }
 
   // Finally, return the constructed list:
   return list;
}

const listToArray = (string, element = 'p') => {
    let div = document.createElement('div');
  
    div.innerHTML = string
  
    let list = div.getElementsByTagName(element)
  
    let data = [];
  
    for(let i=0; i<list.length;i++) {
        data.push(list[i].innerHTML)
    }
  
    return data
}

const createBpIdFrom = (str, id, index) => {
  return `highlight-${str.replace(exceptLettersRegex, '')}-${id}-${index}`
}

let checkIfEmpty = str => {
  return str === '' || !str || str === null || str === undefined
}

function bytesToMegaBytes(bytes) { 
  return bytes / (1024*1024); 
}

function truncateString(str, num) {
  if (str.length > num) {
    return str.slice(0, num) + "...";
  } else {
    return str;
  }
}

function hashInput(input){
  var hash = 0, len = input.length;
  for (var i = 0; i < len; i++) {
    hash  = ((hash << 5) - hash) + input.charCodeAt(i);
    hash |= 0; // to 32bit integer
  }
  return hash;
}

const isDateInThisMonth = (date) => {
    if(isValidDate(date)){
        const creationDate = new Date(date)

        if(currentDate.getMonth() === creationDate.getMonth() && currentDate.getFullYear() === creationDate.getFullYear()){
            return true
        }
    }

    return false;
}

const isValidDate = (date) => {
  if(isNaN(Date.parse(date))){
    return false;
  }
  
  return true;
}

function isOneWeekPassedFrom(givenDate) {
  if(!isValidDate(givenDate)) {
    return false;
  }

  const givenTime = new Date(givenDate).getTime();
  const currentTime = new Date().getTime();

  const oneWeekInMillis = parseInt(process.env.MIX_SHOW_NUDGES_AFTER);

  const timeDifference = currentTime - givenTime;

  if (timeDifference >= oneWeekInMillis) {
      return true;
  } else {
      return false;
  }
}

const filterNumericInput = (evt) => {
  evt = evt ? evt : window.event;

  const charCode = (evt.which) ? evt.which : evt.keyCode;

  if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
    evt.preventDefault();
  } else {
    return true;
  }
}

const formatUrl = (url) => {
    if (url == null || url?.toLowerCase()?.trim() === "n/a") {
        return url;
    }

    if(url === ''){
      return null
    }
    
    if (!url.startsWith("https://")) {
        url = "https://" + url;
    }

    if (!url.startsWith("https://www.") && !url.includes("www.")) {
        url = url.replace("https://", "https://www.");
    }

    return url;
};

const appInDevMode = () => {
  return process.env.NODE_ENV === 'production' ? false : true;
}

const stripe3DSecureEnabled = () => {
  return process.env.MIX_STRIPE_3D_SECURE_ENABLED =='true' ?? false
}

const secondsToTime = (timeInSeconds, withWords=false, appendZero=true) => {
  let minutes = Math.floor(timeInSeconds / 60);
  let seconds = Math.round(timeInSeconds - minutes * 60);

  if (minutes < 10 && appendZero) {
      minutes = `0${minutes}`;
  }

  if (seconds < 10 && appendZero) {
      seconds = `0${seconds}`;
  }

  if(withWords){
    return `${minutes} minutes ${Math.round(seconds)} seconds`;
  }

  return `${minutes}:${Math.round(seconds)}`;
}

function formatSecondsToTime(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
  }

const getColorForProgress = (progress) => {
  let numericalValue;

  try {
    numericalValue = parseInt(progress)
  } catch (error) {
    return PROGRESS_COLORS.gray
  }

  if(isNaN(numericalValue)){
    return PROGRESS_COLORS.gray
  }

  if (numericalValue < 30) {
      return PROGRESS_COLORS.gray
  }else if (numericalValue < 50) {
      return PROGRESS_COLORS.red
  } else if (numericalValue < 75) {
      return PROGRESS_COLORS.yellow
  }

  return PROGRESS_COLORS.green
}

const openLink = (url, inNewPage = false) => {
  const link = document.createElement('a');
  link.href = url;

  if(inNewPage){
    link.target = '_blank';
  }

  document.body.appendChild(link);

  link.click();
  link.remove();
}

const allowDownloadDOCX = () => {
    return process.env.MIX_SHOW_DOWNLOAD_DOCX === 'true' ?? false
}

const fixContentFormat = (content) => {
    if(content == null || content === "<ul></ul>" ) return null

    let result;

    //decode html entities
    result = decode(content)

    // replace backslashes
    result = result.replace(/<\\/g, '<')

    //remove quote symbol
    if(result[0] === '"'){
        result = result.slice(1)
    }

    if(result[result.length - 1] === '"'){
        result = result.slice(0, result.length - 1)
    }

    return result;
}

const formatNumberWithCommas = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const formatNumberToK = (number) => {
  if (number % 1000 === 0 && number >= 1000) {
      return (number / 1000).toFixed(0) + 'K';
  }

  return number.toString();
}

export const isNetworkV2Enabled = () => {
  return process.env.MIX_NETWORK_v2 === "true" ? true : false
}

const getAppEnvFromHost = () => {
  const host = location.host;

  return HOSTS_MAP?.[host] || 'unknown'
}

const isSocialMediaAppBrowser = () =>{
  const ua = navigator.userAgent.toLowerCase().trim();
  return REDIRECT_FROM_SN.filter(sn => ua.includes(sn)).length > 0;
}

const getDaysDiffAfter = (date) => {
    const startDate = moment(date);
    const currentDate = moment();

    return currentDate.diff(startDate, 'days');
}

const formatUrlParams = params => {
    if(params === '' || params == null) {
        return ''
    }

    const paramsPairs = Object.keys(params).map(key => {
        return `${key}=${encodeURIComponent(params[key])}`
    })

    return `?${paramsPairs.join('&')}`;
}

const getWorkExperienceWithPoints = (currentSelectedResume) => {
    if (!currentSelectedResume || !currentSelectedResume.sections) return '';

    const workExperienceSection = currentSelectedResume.sections.find(
        (section) => section.type === 'work_experience'
    );

    if (!workExperienceSection || !workExperienceSection.items) return '';

    const workExperienceText = workExperienceSection.items
        .map((item) => {
            // Extract heading and title, cleaning HTML tags
            const heading = item.heading
                ? item.heading.replace(/<\/?[^>]+(>|$)/g, '').trim()
                : '';
            const title = item.title
                ? item.title.replace(/<\/?[^>]+(>|$)/g, '').trim()
                : '';

            // Extract and clean bullet points
            const points = item.bullet_points
                ? item.bullet_points
                    .replace(/<\/?p>/g, '') // Remove <p> tags
                    .replace(/<\/?ul>|<\/?li>/g, '') // Remove <ul> and <li> tags
                    .trim()
                : '';

            // Combine heading, title, and points
            let entryText = heading ? `Company: ${heading}` : '';
            entryText += title ? `\nTitle: ${title}` : '';
            entryText += points ? `\nPoints:\n${points}` : '';

            return entryText.trim(); // Return the formatted entry
        })
        .filter(Boolean)
        .join('\n\n');

    return workExperienceText ?? '';
};

const getCommunityResumeLink = (resumeId) => {
    return `${location.origin}/community?resume=${resumeId}`;
}

const displayYear = (value) => {
  if (value === 1) {
    return 'year';
  } else if (value < 10) {
    return 'years';
  } 
  return ' +years';
}

const sanitizeHtmlText = (text) => {
  return sanitizeHtml(text, {allowedTags: []})
}

const isJobAlertsEnabled = () => {
  return process.env.MIX_SHOW_JOB_ALERTS === "true" ? true : false
}

const isJobRecommendationsEnabled = () => {
  return process.env.MIX_SHOW_JOB_RECOMMENDATIONS === "true" ? true : false
}

const isJobDescriptionSummaryEnabled = () => {
    return process.env.MIX_SHOW_JOB_DESCRIPTION_SUMMARY === "true" ? true : false
}

const getFilterByValue = (filterOptions, item) => {
    const response = filterOptions.find(el => el.value === item)
    return response
}

export {
    hashInput,
    getCurrentVersion,
    bytesToMegaBytes,
    truncateString,
    extractContent,
    checkIfEmpty,
    hexToRgb,
    rgbToHex,
    isValidHttpUrl,
    listToArray,
    arraytoList,
    capitalizeFirstLetterEveryWord,
    capitalizeFirstLetter,
    throttle,
    debounce,
    isInViewport,
    calcScreenDPI,
    getHeightForA4Page,
    decodeHtmlEntities,
    decodeHtml,
    sort_by_key,
    roundNearest,
    formatErrors,
    validateEmail,
    copyToClipboard,
    popupwindow,
    makeid,
    isDateInThisMonth,
    isSubscriptionModelActivated,
    isJobSearchBlockersEnabled,
    isValidUrl,
    filterNumericInput,
    formatUrl,
    createBpIdFrom,
    appInDevMode,
    isTailorTargetButtonEnabled,
    stripe3DSecureEnabled,
    secondsToTime,
    formatSecondsToTime,
    getColorForProgress,
    openLink,
    isOneWeekPassedFrom,
    allowDownloadDOCX,
    fixContentFormat,
    formatNumberWithCommas,
    formatNumberToK,
    getAppEnvFromHost,
    getDaysDiffAfter,
    isSocialMediaAppBrowser,
    formatUrlParams,
    getWorkExperienceWithPoints,
    getCommunityResumeLink,
    displayYear,
    sanitizeHtmlText,
    isJobAlertsEnabled,
    isJobRecommendationsEnabled,
    isJobDescriptionSummaryEnabled,
    getFilterByValue,
}
